"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIntersection = void 0;
const React = __importStar(require("react"));
const defaultOptions = {
    root: document.body,
    rootMargin: '0px',
    threshold: 1,
};
function useIntersection(ref, options, stopOnVisible = true) {
    options = { ...defaultOptions, ...options };
    const [visible, setVisible] = React.useState(false);
    React.useEffect(() => {
        if (!ref.current || (visible && stopOnVisible))
            return;
        const observer = new IntersectionObserver(entries => {
            entries.forEach(({ isIntersecting, intersectionRatio }) => {
                if (isIntersecting && stopOnVisible && ref.current) {
                    observer.unobserve(ref.current);
                    setTimeout(() => {
                        setVisible(isIntersecting);
                    });
                }
                else if (!stopOnVisible) {
                    setVisible(isIntersecting);
                }
            });
        }, options);
        observer.observe(ref.current);
        return () => {
            ref.current && observer.unobserve(ref.current);
        };
    }, [ref, stopOnVisible, options]);
    return visible;
}
exports.useIntersection = useIntersection;
